<template>
  <div
    v-if="getErrorData"
    class="floating-toast"
    :class="{ 'is-active': showErrorToast }"
  >
    <div class="floating-toast__wrapper">
      <div>
        <p
          v-if="getErrorData.title"
          class="floating-toast__title text-body-s-bold"
          v-text="getErrorData.title"
        />
        <p
          v-if="getErrorData.description"
          class="floating-toast__description text-body-s-regular"
          v-text="getErrorData.description"
        />
      </div>
      <button
        type="button"
        class="floating-toast__button"
        :aria-label="$string('accessibility.close')"
        @click="setShowError(false)"
      >
        <icon-close />
      </button>
    </div>
  </div>
</template>

<script>

/**
 * Vue: floating-toast (floating-toast)
 * -----------------------------------------------------------------------------
 * For showing user warnings.
 *
 */
import { mapActions, mapGetters, mapState } from 'vuex'
import IconClose from '~icons/directional-navigation/close.svg'

export default {
  name: 'FloatingToast',

  components: {
    IconClose,
  },

  data() {
    return {
      cnvsGlobal: true,
    }
  },

  computed: {

    /**
     * Map Vuex getters.
     */
    ...mapGetters({
      getErrorData: 'product-eval-copy/getErrorData',
    }),

    /**
     * Map Vuex state.
     */
    ...mapState({
      showErrorToast: (state) => state['product-eval-copy'].showErrorToast,
    }),
  },

  watch: {
    showErrorToast() {
      if (this.showErrorToast) {
        setTimeout(() => {
          this.hideToast()
        }, 20000)
      }
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      setShowError: 'product-eval-copy/setShowError',
    }),

    /**
     * Makes toast invisible
     */
    hideToast() {
      this.setShowError(false)
    },
  },
}
</script>
